var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.documentData)?_c('div',[_c('iframe',{attrs:{"src":_vm.documentData,"width":"100%","height":"700px"}})]):_vm._e(),(_vm.errorMessage)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.errorMessage))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }